// eslint-disable-next-line import/no-unresolved
import { Flex, Text, TextButton } from '@modusign/design-system';
import * as CSS from 'csstype';

interface ErrorFallbackMessageProps {
  description: string;
  height?: CSS.Property.Height;
  onClick: () => void;
}

const ErrorFallbackMessage = ({ description, height, onClick }: ErrorFallbackMessageProps) => {
  return (
    <Flex
      alignItems="center"
      flexDirection="column"
      height={height ?? '100%'}
      justifyContent="center"
      width="100%"
    >
      <Text as="p" mb={3}>
        {description}
      </Text>
      <TextButton onClick={onClick}>다시 시도하기</TextButton>
    </Flex>
  );
};

export default ErrorFallbackMessage;
